import { ScheduledGameConfirmationScreen } from '@/screens/scheduled-game-confirmation'

export default function () {
  return <ScheduledGameConfirmationScreen />
}
